import Vue from 'vue'
import Router from 'vue-router'
import routers from './systemRouters.js'
import customRouters from './customRouters.js'
import dialog from '@/components/dialog'
import {VuexStore} from '@/core/storage'

Vue.use(Router)

//合并系统生成的路由到自定义路由上
function mergeRouters(router1, router2) {
    function copy(src) {
        let item = JSON.parse(JSON.stringify(src));

        item.component = src.component;
        if (item.children != null) {
            for (let j = 0; j < item.children.length; j++) {
                item.children[j].component = src.children[j].component;
                item.children[j].props = src.children[j].props;
            }
        }

        return item;
    }

    function find(list, item) {
        for (let i = 0; i < list.length; i++) {
            if (list[i].path === item.path) return list[i];
        }

        return null;
    }

    function merge(list, item) {
        let temp = find(list, item);
        if (temp == null) {
            temp = copy(item);
            list.push(temp);
        }
        else {
            if (item.children != null) {
                if (temp.children == null) temp.children = [];
                for (let j = 0; j < item.children.length; j++) {
                    merge(temp.children, item.children[j]);
                }
            }
        }
    }

    for (let i = 0; i < router2.length; i++) {
        merge(router1, router2[i]);
    }

    return router1;
};

const router = new Router({
    mode: 'hash',
    routes: mergeRouters(customRouters, routers),
});

/**
 * 路由跳转的时候判断token是否存在
 */
router.beforeResolve((to, from, next) => {
    if (to.name === 'login') {
        next();
    }
    else {
        let token = VuexStore.getValue('token');
        if (!token || !/\S/.test(token)) {
            dialog.closeAll();
            next({ name: 'login' })
        }
        else {
            next();
        }
    }
})

export default router;


// WEBPACK FOOTER //
// ./src/router/index.js